
import loadable from '@loadable/component'

export default {
    '/:type/my/orders': loadable(() => import('./OrderList')),
    '/:type/mall/order/:tradeNo': loadable(() => import('./OrderDetail')), // 订单详情
    '/:type/mall/shopOrderDetail/:mainTradeNo': loadable(() => import('./OrderDetail')), // 购物车订单详情
    '/:type/my/refundDetail': loadable(() => import('./RefundDetail')), // 退款页面
    '/:type/my/refundRecord': loadable(() => import('./RefundRecord')), // 退款列表
    '/:type/my/returnGoodsStep': loadable(() => import('./returnGoodsStep')), // 退款详情页面
    '/:type/my/applicationDetails': loadable(() => import('./applicationDetails')), // 退款申请详情页面
    '/:type/my/deliverLogisticsList': loadable(() => import('./DeliverLogisticsList')), // 退款申请详情页面
    '/:type/my/shoppingCart': loadable(() => import('./shoppingCart')), // 购物车页面
}
